<template>
<div class="search_container searchArea">
    <el-form :inline="true" :model='searchInfo' ref="searchInfo" :rules="rules">
        <el-form-item label="水司名称">
            <el-input v-model="searchInfo.name" @change="nameChange" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="searchList()">查询</el-button>
            <el-button type="primary" @click="addEnpr()">新增水司</el-button>
        </el-form-item>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: 'searchItem',
    props: {
        searchInfo: {
            type: Object,
            required: true
        }

    },
    data() {
        return {
            rules: {}
        }
    },
    computed: {},
    created() {},
    methods: {
        // 查询
        searchList() {
            this.$emit('searchList', this.searchInfo)
        },
        addEnpr(){
             this.$emit('addEnpr')
        },
        nameChange(e) {
            this.searchInfo.name = e
            this.$emit('update:searchInfo', this.searchInfo)
        }
    }
}
</script>

<style>
.search_container {
    padding: 40px 0 18px;
}
.el-date-editor .el-range-separator{
    padding:0;
}
</style>
